import {TextEditor} from "./TextEditor.js";
import {valueOrDefault} from "../utils/Util.js";
import {Temp} from "../utils/Temp.js";
import {MorePanel} from "./MorePanel.js";
import {completeUrl} from "../utils/ActionLink.js";
import {openNewMailWindow} from "../intouch.js";
import {msg} from "@/i18n/Message.ts";

export class EAddressEditor extends TextEditor {

	constructor(parent, fieldPath, obj, member, widgetOptions) {
		super(parent, fieldPath, obj, member, widgetOptions);
		this.tagEnabled = typeof widgetOptions.tags !== 'undefined';
	}

	rebuild() {
		super.rebuild();
		const eaw = $('<div class="ea-wrapper"></div>');
		const ea = $('<div class="ea-editor"></div>');
		ea.append(this.root);	// generated by super.rebuild
		this.rightTags = $('<div class="ea-tag ea-right"></div>');
		ea.append(this.rightTags);
		this.widget.css('width', '168px');
		this.widget.attr('placeholder', msg('placeholder.eaddress'));
		eaw.append(ea);
		this.root = eaw;	// replace root element with ea wrapper
		this.updateIcon();

		if (this.tagEnabled) {
			this.morePanel = this.buildMorePanel();
			eaw.append(this.morePanel);
			this.moreArrow = new MorePanel(this.morePanel, false, true).ui;
			ea.append(this.moreArrow);
		}

		// Bind
		if (this.inArray) {
			const keyDownHandler = function (e) {
				if (e.keyCode === 13 /* enter */) {
					e.preventDefault();
					if (this.widget.val().length > 0) {
						this.parent.insertAfter(this.arrayRow);
					}
				} else if (e.keyCode === 8 /* backspace */) {
					if (this.widget.val().length === 0) {
						e.preventDefault();
						this.parent.removeItem(this.arrayRow);	// remove me from the array
					}
				}
			}.bind(this);
			this.widget.on('keydown', keyDownHandler);
		}
	}

	tagCheckboxChange(chb) {
		const arraySet = super.data.tags;
		const add = chb.is(':checked');
		const val = chb.val();
		const aidx = $.inArray(val, arraySet);
		if (aidx < 0 && add) arraySet.push(val);
		else if (aidx >= 0 && !add) arraySet.splice(aidx, 1);
		// change style
		let areaStyle = this.originalStyle || '';
		for (let j = 0; j < this.options.tags.length; j++) {
			if ($.inArray(this.options.tags[j].value, arraySet) >= 0 && this.options.tags[j].spec.length>0) areaStyle = areaStyle + ';'+ this.options.tags[j].spec;
		}
		this.widget.attr('style', areaStyle);
	}

	buildMorePanel() {
		this.originalStyle = this.widget.attr('style');
		const morePanel = $('<div class="ea-more" style="display:none"></div>');
		let areaStyle = this.originalStyle || '';

		const d = super.data;
		let arraySet = d.tags;
		if (typeof arraySet === 'undefined' || arraySet === null) {
			arraySet = []; // make empty set
			d.tags = arraySet;
		}

		for (let i = 0; i < this.options.tags.length; i++) {
			const tgItem = this.options.tags[i];
			const lab = Temp.tag('label', {});
			const chb = Temp.checkbox({ });
			chb.attr('value', tgItem.value);
			if ($.inArray(tgItem.value, arraySet) >= 0) {
				chb.attr('checked', 'true');
				if (tgItem.spec.length > 0) areaStyle = areaStyle +';'+ tgItem.spec;
			}
			lab.text(' '+tgItem.name);
			lab.prepend(chb);
			chb.on('change', this.tagCheckboxChange.bind(this, chb));
			morePanel.append(lab);
		}
		this.widget.attr('style', areaStyle);
		return morePanel;
	}

	enableWidget(enable) {
		super.enableWidget(enable);
		if (this.morePanel) {
			const tagBoxes = this.morePanel.find("input[type=checkbox]");
			if (enable) tagBoxes.removeAttr('disabled');
			else tagBoxes.attr('disabled', 'disabled');
		}
	}

	get data() {
		const eaObj = super.data;
		return valueOrDefault(eaObj.value, '');
	}

	set data(newValue) {
		const eaObj = super.data;
		const oldValue = this.data;
		const wasChange = oldValue !== newValue;
		eaObj.value = newValue;
		if (wasChange) this.wasChange(newValue);
	}

	updateScreen() {
		super.updateScreen();
		if (this.rightTags != null) this.updateIcon();
	}

	wasChange(newValue) {
		let stopBubble;
		if (!super.wasChange(newValue)) {
			this.updateIcon();
			this.widget.removeClass("junk");
			const eaObj = super.data;
			eaObj.junk = false;
			eaObj.type = 0;	// type must be detected on the server
			this.clearError();
			return false;
		} else return true;
	}

	static startsWithProtocolName(url) {
		if (url === null) return false;
		const u = url.toLowerCase();
		return u.startsWith("http://") || u.startsWith("https://") || u.startsWith("ftp://");
	}

	updateIcon() {
		// public static final String[] PHONE_EXT_SEPARATOR = new String[] { "#", "ext", "kl", "x", ";" };
		const PHONE_REGEX = /^\+?[0-9\/\(\)\-\s]{5,20}((#|ext\.?|kl\.?|x|;)\s*(\d{1,10}))?$/;
		const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const HOST_REGEX = /^([a-z0-9][a-z0-9\-_]*\.)+[a-z]{2,8}$/gi;

		const data = this.data.trim();

		let type = 'UNKNOWN';
		if (data.length == 0) type = 'EMPTY';
		else if (PHONE_REGEX.test(data)) type = 'PHONE';
		else if (EMAIL_REGEX.test(data)) type = 'EMAIL';
		else if (EAddressEditor.startsWithProtocolName(data) || HOST_REGEX.test(data)) type = 'WEB';

		let icon = "phone";
		let onclick = null;
		let href = null;
		this.ok = true;

		console.log(data + " = " + type);
		switch (type) {
			case 'PHONE':
				icon = "phone";
				let ctx = this.option("context", "");
				if (ctx.length > 0) {
					onclick = function (elm, evt) {
						if (ctx.startsWith('?') || ctx.startsWith('&')) ctx = ctx.substring(1);
						showActionDialog(this.rightTags, ctx, null, this.widget.val());
					}.bind(this);
				}
				break;
			case 'EMAIL':
				icon = "email";
				if (this.option("hasMailAccount", false)) {
					onclick = function (elm, evt) {
						let ctx = this.option("context", "");
						if (ctx.startsWith('?') || ctx.startsWith('&')) ctx = ctx.substring(1);
						openNewMailWindow('?recipient='+this.widget.val()+'&'+ctx);
					}.bind(this);
				} else href = 'mailto:'+data;
				break;
			case 'WEB':
				icon = "web";
				href = completeUrl(data);
				break;
			case 'UNKNOWN':
				icon = 'warning-18-bold';
				this.ok = false;
				break;
		}
		const iconImg = $(Icon.fi(icon, "fi-input"));
		this.rightTags.empty();
		if (onclick !== null) {
			iconImg.addClass("link-like-fi");
			iconImg.on('click', function(e) { onclick(iconImg, e); });
			this.rightTags.append(iconImg);
		} else if (href !== null) {
			let ln = $('<a target="_blank"></a>');
			ln.attr('href', href);
			ln.append(iconImg);
			this.rightTags.append(ln);
		} else this.rightTags.append(iconImg);

		if (super.data.junk) this.widget.addClass("junk");
	}
}
